<div class="tooltip-container" [attr.data-type]="type">
  <div class="tooltip-wrapper">
    <div
      class="tooltip-box"
      @tooltipAnimation
      [attr.data-type]="type"
      [innerHTML]="tooltip.description"
      #tooltipContainer
    ></div>
    <div
      *ngIf="type === 'click'"
      class="close-button"
      (click)="closeTooltip($event)"
    >
      <hdi-icon
        iconName="close"
        [size]="Sizes.MEDIUM"
        [color]="Colors.WHITE"
        [isHover]="true"
      ></hdi-icon>
    </div>
  </div>
  <div class="arrow" [attr.data-type]="type" @tooltipAnimation></div>
</div>
